import { defineMessages } from "react-intl";

const baseId = "t.components.modals.basicDateModal.";

export default defineMessages({
  title: {
    id: baseId + "title",
    defaultMessage: "Modify validity",
  },
  date: {
    id: baseId + "date",
    defaultMessage: "Date",
  },
  finishDate: {
    id: baseId + "finishDate",
    defaultMessage: "Finish Date",
  },
  confirm: {
    id: baseId + "confirm",
    defaultMessage: "Confirm",
  },
  cancel: {
    id: baseId + "cancel",
    defaultMessage: "Cancel",
  },
});
